export abstract class MimeTypes {
    static readonly pdf = 'application/pdf';
    static readonly jpeg: string = 'image/jpeg';
    static readonly png: string = 'image/png';
    static readonly docx: string = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    static readonly doc: string = 'application/msword';
}
